module.exports = __webpack_public_path__ + "img/chat.2b770552.svg";